import { makeAutoObservable, runInAction } from 'mobx';
import { Project } from '../shared/models/Project';
import { ProjectProgress } from '../shared/models/ProjectProgress';
import { ProjectService } from '../services/ProjectService';
import { ProjectProgressService } from '../services/ProjectProgressService';

export class ProgressDetailViewModel {
  project: Project | null = null;
  progress: ProjectProgress | null = null;
  loading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async load(progressId: string, projectId: string) {
    this.loading = true;
    this.error = null;
    try {
      const [progress, project] = await Promise.all([
        ProjectProgressService.getProjectProgressById(progressId),
        ProjectService.getProjectById(projectId),
      ]);
      runInAction(() => {
        this.progress = progress;
        this.project = project;
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err instanceof Error ? err.message : '加载进展详情失败';
        this.loading = false;
      });
    }
  }
}








